export default __webpack_public_path__ + "static/4.74d232fab271c6e937c48348b72db5ed.png";